export const suspensionData = [
  {
    id: 1,
    name: 'RockShox Fork',
    rebuildInt: 200,
    sealInt: 50,
    serviceLink: 'https://www.youtube.com/watch?v=q71iSEEuiw0',
  },
  {
    id: 2,
    name: 'RockShox Rear Shock',
    rebuildInt: 200,
    sealInt: 50,
    serviceLink: 'https://www.youtube.com/watch?v=ngdHH8Q2Zs4',
  },
  {
    id: 3,
    name: 'Fox Fork',
    rebuildInt: 100,
    sealInt: 30,
    serviceLink: 'https://www.ridefox.com/fox17/help.php?m=bike&listall=service',
  },
  {
    id: 4,
    name: 'Fox Rear Air Shock',
    rebuildInt: 100,
    sealInt: 30,
    serviceLink: 'https://www.ridefox.com/fox17/help.php?m=bike&listall=service',
  },
  {
    id: 5,
    name: 'Fox Rear Coil Shock',
    rebuildInt: 100,
    sealInt: null,
    serviceLink: 'https://www.ridefox.com/fox17/help.php?m=bike&id=683',
  },
  {
    id: 6,
    name: 'Ohlins Fork',
    rebuildInt: 100,
    sealInt: 30,
    serviceLink: 'https://www.ohlins.com/support/manuals/mtb-manuals/',
  },
  {
    id: 7,
    name: 'Ohlins Rear Shock',
    rebuildInt: 100,
    sealInt: 50,
    serviceLink: 'https://www.ohlins.com/support/manuals/mtb-manuals/',
  },
  {
    id: 8,
    name: 'DVO Fork',
    rebuildInt: 100,
    sealInt: 50,
    serviceLink: 'http://tech.dvosuspension.com/service-guides/diamond/',
  },
  {
    id: 9,
    name: 'DVO Rear Shock',
    rebuildInt: 100,
    sealInt: 50,
    serviceLink: 'http://tech.dvosuspension.com/service-guides/diamond/',
  },
  {
    id: 10,
    name: 'Marzocchi Fork',
    rebuildInt: 125,
    sealInt: null,
    serviceLink: 'https://www.ridefox.com/fox17/help.php?m=bike&listall=service',
  },
  {
    id: 11,
    name: 'Marzocchi Rear Shock',
    rebuildInt: 125,
    sealInt: null,
    serviceLink: 'https://www.ridefox.com/fox17/help.php?m=bike&listall=service',
  },
  {
    id: 12,
    name: 'X-Fusion Fork',
    rebuildInt: 100,
    sealInt: 25,
    serviceLink: 'https://drive.google.com/file/d/1MCs7Qv3hxzj_7KOGRA-6iiCp9W9L_nme/view',
  },
  {
    id: 13,
    name: 'X-Fusion Rear Shock',
    rebuildInt: 100,
    sealInt: 25,
    serviceLink: 'https://drive.google.com/file/d/1MCs7Qv3hxzj_7KOGRA-6iiCp9W9L_nme/view',
  },
  {
    id: 14,
    name: 'MRP Fork',
    rebuildInt: 100,
    sealInt: 50,
    serviceLink: 'https://mrpbike.com/pages/tech-resources',
  },
  {
    id: 15,
    name: 'MRP Rear Shock',
    rebuildInt: 100,
    sealInt: 50,
    serviceLink: 'https://mrpbike.com/pages/tech-resources',
  },
  {
    id: 16,
    name: 'Cane Creek Fork',
    rebuildInt: 100,
    sealInt: 50,
    serviceLink: 'https://blue.canecreek.com/tech-center/suspension/service-videos#EFNWzkICEoE',
  },
  {
    id: 17,
    name: 'Cane Creek Rear Air Shock',
    rebuildInt: 100,
    sealInt: null,
    serviceLink: 'https://www.youtube.com/user/CaneCreekCycling/videos',
  },
  {
    id: 18,
    name: 'Cane Creek Rear Coil Shock',
    rebuildInt: 100,
    sealInt: null,
    serviceLink: 'https://www.youtube.com/user/CaneCreekCycling/videos',
  },
  {
    id: 19,
    name: 'Push Rear Coil Shock',
    rebuildInt: 100,
    sealInt: 30,
    serviceLink: 'https://www.pushindustries.com/pages/elevensix-support',
  },
  {
    id: 20,
    name: 'Unlisted suspension',
    rebuildInt: 100,
    sealInt: 50,
    serviceLink: null,
  }
]